import { render, staticRenderFns } from "./ButtonsTab.vue?vue&type=template&id=29644a4e&scoped=true&"
import script from "./ButtonsTab.vue?vue&type=script&lang=js&"
export * from "./ButtonsTab.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsTab.vue?vue&type=style&index=0&id=29644a4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29644a4e",
  null
  
)

export default component.exports